import React, { useRef, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { VolumeUp as VolumeIcon, StopCircleOutlined as StopIcon } from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const audioUrl = (file) => `${API_URL}/audio/files/${file}`;

const LABELS = { fr: 'Écouter la prononciation', en: 'Listen to the pronunciation', es: 'Escuchar la pronunciación', de: 'Aussprache anhören' };

// Bouton « écouter » d'un mot. Le son n'est telecharge qu'au clic.
function PlayWordButton({ file, language = 'fr' }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  if (!file) return null;
  const toggle = () => {
    if (playing && ref.current) {
      ref.current.pause();
      ref.current.currentTime = 0;
      setPlaying(false);
      return;
    }
    const audio = new Audio(audioUrl(file));
    ref.current = audio;
    audio.onended = () => setPlaying(false);
    audio.onerror = () => setPlaying(false);
    setPlaying(true);
    audio.play().catch(() => setPlaying(false));
  };

  return (
    <Tooltip title={LABELS[language] || LABELS.fr}>
      <IconButton size="small" onClick={toggle} aria-label={LABELS[language] || LABELS.fr} sx={{ color: 'primary.main' }}>
        {playing ? <StopIcon fontSize="small" /> : <VolumeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}

export default PlayWordButton;
